import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AnyHandler } from 'src/app/types/@types/sl-v-types';
import { SLLayer } from 'src/app/model/sl-layer';

export interface PopupEditorParams {
	handler: AnyHandler;
	layer: SLLayer;
}


@Injectable({
	providedIn: 'root'
})
export class ResultsPopupEditorDialogService {

	public request$: Subject<PopupEditorParams> = new Subject();
	constructor() { }


	Show(handler: AnyHandler, layer: SLLayer) {
		this.request$.next({
			handler: (handler),
			layer: (layer)
		});

	}
}
